module.exports = "body{\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n.container {\r\n    width: 100%;\r\n    margin: 0;\r\n    min-width: 560px;\r\n}\r\n.content-container {\r\n    padding: 20px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main